export default __webpack_public_path__ + "static/media/0113.03299cb9.jpg";